import { useEffect, useState } from "react";
import { AGENT_SCRIPT_MODE, MOBILE_BREAKPOINT } from "./agentScriptConfig";

export const useAgentScriptMode = (): "inline" | "tooltip" => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    if (AGENT_SCRIPT_MODE !== "responsive") return;

    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  if (AGENT_SCRIPT_MODE === "always-inline") return "inline";
  if (AGENT_SCRIPT_MODE === "always-tooltip") return "tooltip";
  return isMobile ? "tooltip" : "inline";
};
